import { ReactRenderer } from '@tiptap/react'
import { SuggestionOptions, SuggestionProps } from '@tiptap/suggestion';
import { MentionNodeAttrs } from '@tiptap/extension-mention';
import tippy from "tippy.js";
import { IUserData } from 'Data/interfaces/User/IUserData';
import MentionListUser, { MentionListUserRef } from './components/MentionListUser'

export type SuggestionPropsType = SuggestionProps<IUserData, MentionNodeAttrs>

export type SuggestionType = Omit<SuggestionOptions<IUserData, MentionNodeAttrs>, "editor">

const userSuggestion = (
  usersOptions: IUserData[],
  assignedUsers: IUserData[],
  followersUsers: IUserData[],
): SuggestionType => ({
  char: '@',
  items(props) {
    return usersOptions.filter(user => {
      return user.Nome?.toLowerCase().includes(props.query.toLowerCase());
    });
  },
  render: () => {
    let reactRenderer: ReactRenderer<MentionListUserRef, SuggestionPropsType>;
    let popup: any;

    return {
      onStart: (props) => {
        reactRenderer = new ReactRenderer(MentionListUser, {
          props: {
            ...props,
            assignedUsers,
            followersUsers,
          },
          editor: props.editor,
        });

        popup = tippy("body", {
          getReferenceClientRect: props.clientRect as any,
          appendTo: () => document.body,
          content: reactRenderer.element,
          showOnCreate: true,
          interactive: true,
          trigger: "manual",
          placement: "bottom-start"
        });
      },
      onUpdate(props) {
        reactRenderer.updateProps(props);

        popup[0].setProps({
          getReferenceClientRect: props.clientRect
        });
      },
      onKeyDown(props) {
        return reactRenderer.ref?.onKeyDown(props) ?? false;
      },
      onExit() {
        popup[0].destroy();
        reactRenderer.destroy();
      }
    };
  }
});

export default userSuggestion;
